var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var directives;
    (function (directives) {
        var MultiStepForm = /** @class */ (function (_super) {
            __extends(MultiStepForm, _super);
            function MultiStepForm() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.templateUrl = './app/views/directives/inputForm/multiStepForm.html';
                _this.controller = [
                    '$scope', '$window', '$timeout', 'angularLoadService', 'formSectionService', 'ModalService', '$http',
                    'dataSourceService', 'formService', 'formDataService', 'growl', 'formCodeFunctionService',
                    'customDivService',
                    'manageProcessDataConfigurationService', 'apiActionService', 'securityMatrixService',
                    'deleteService', MultiStepFormController
                ];
                return _this;
            }
            return MultiStepForm;
        }(directives.BaseForm));
        directives.MultiStepForm = MultiStepForm;
        var MultiStepFormModel = /** @class */ (function (_super) {
            __extends(MultiStepFormModel, _super);
            function MultiStepFormModel(angularLoader, formSectionService, modalService, $http, dataSourceService, formService, process, formDataService, growl, formCodeFunctionService, customDivService, manageProcessDataConfigurationService, apiConfigurationService, securityMatrixService, deleteService, scope, $window, $timeout, formDataId) {
                var _this = _super.call(this, angularLoader, formSectionService, modalService, $http, dataSourceService, formService, process, formDataService, growl, formCodeFunctionService, customDivService, manageProcessDataConfigurationService, apiConfigurationService, securityMatrixService, deleteService, scope, formDataId) || this;
                _this.$window = $window;
                _this.$timeout = $timeout;
                var cb = scope.$on('stepChanged', function (e, a) {
                    var step = Enumerable.from(_this.formConfiguration.mySteps).singleOrDefault(function (x) { return x.id === a; });
                    //console.log(step);
                    if (step) {
                        _this.selectStep(step.position);
                        scope.$apply();
                    }
                });
                //destroy the listener on scope destroy to avoid memory leak
                scope.$on("$destroy", function () {
                    cb();
                });
                return _this;
            }
            MultiStepFormModel.prototype.setupImplementedForm = function () {
                if (this.formConfiguration.mySteps.length > 0) {
                    if (this.isFieldChangedProcessAction) {
                        this.isFieldChangedProcessAction = false;
                        return;
                    }
                    //********
                    //TODO: Hack by Randy: this preserves the step the user is on in a multi-step form after a process action is run
                    // this is potentially vulnerable to form visibility changes
                    //** prior to change
                    //this.selectStep(0);
                    //** end prior to change
                    //** change
                    if (isNaN(this.currentStepIndex)) {
                        this.selectStep(0);
                    }
                    else {
                        this.selectStep(this.currentStepIndex);
                    }
                    //** end change
                    //this.loadStepUrls();
                }
            };
            MultiStepFormModel.prototype.goto = function (errorObj) {
                var step = Enumerable.from(this.formConfiguration.mySteps).single(function (x) { return x.id == errorObj.stepId; });
                this.selectStep(step.position);
                //this.currentStep = step;
                //this.currentStepIndex = step.position;
                if (errorObj.rowId) {
                    setTimeout(function () {
                        $('#' + errorObj.rowId).click();
                        setTimeout(function () { $('#' + errorObj.fieldId).focus(); }, 100);
                    }, 100);
                }
                else {
                    setTimeout(function () { $('#' + errorObj.fieldId).focus(); }, 100);
                }
            };
            MultiStepFormModel.prototype.deleteStep = function () {
                var _this = this;
                var deletedStep = this.currentStep.position;
                this.deleteService.deleteWithModalConfirmIfNecessary('FormStep', this.currentStep.id, "Form Step", function () {
                    _this.formConfiguration.mySteps.forEach(function (s) {
                        if (s.position > deletedStep) {
                            s.position--;
                        }
                    });
                    _this.formConfiguration.mySteps.splice(_this.currentStep.position, 1);
                    _this.setupFormSchema();
                    _this.save();
                    if (_this.formConfiguration.mySteps.length > 0) {
                        _this.selectStep(0);
                    }
                    else {
                        _this.currentStep = null;
                    }
                });
            };
            MultiStepFormModel.prototype.previous = function (event) {
                var element = angular.element(event.currentTarget);
                element.blur();
                this.selectAndScrollToStep(this.currentStepIndex - 1);
            };
            MultiStepFormModel.prototype.next = function (event) {
                var element = angular.element(event.currentTarget);
                element.blur();
                this.selectAndScrollToStep(this.currentStepIndex + 1);
            };
            MultiStepFormModel.prototype.selectAndScrollToStep = function (stepIndex) {
                this.selectStep(stepIndex);
            };
            MultiStepFormModel.prototype.stepSort = function ($item, $partFrom, $partTo, $indexFrom, $indexTo, $modal) {
                var arrayCopy = Enumerable.from($partFrom).orderBy(function (z) { return z.position; }).toArray();
                var spliced = arrayCopy.splice($indexFrom, 1);
                arrayCopy.splice($indexTo, 0, spliced[0]);
                $item.position = $indexTo;
                for (var i = 0; i < $partFrom.length; i++) {
                    var numberId = $partFrom[i].id;
                    $partFrom[i].position = Enumerable.from(arrayCopy).indexOf(function (i) { return i.id == numberId; });
                }
                this.save();
                this.selectStep($indexTo);
            };
            //public addCustomStep() {
            //    var newStep = this.formService.createFormStep(this.formConfiguration);
            //    newStep.position = this.formConfiguration.mySteps.length;
            //    newStep.objectSchema = this.dataSourceService.createNewObjectSchema();
            //    newStep.objectSchema.name = "Step Name";
            //    newStep.isCustomStep = true;
            //    var self = this;
            //    this.$http.get('./app/views/customStepTemplate.html').then(function (result) {
            //        newStep.html = <string>(result.data);
            //        return self.$http.get('./app/models/customStepTemplate.js');
            //    }).then(result => {
            //        newStep.javascript = <string>(result.data);
            //        self.save();
            //    });
            //    this.formConfiguration.mySteps.push(newStep);
            //    this.currentStep = newStep;
            //}
            MultiStepFormModel.prototype.addStep = function () {
                var newStep = this.formService.createFormStep(this.formConfiguration);
                newStep.position = this.formConfiguration.mySteps.length;
                newStep.objectSchema = this.dataSourceService.createNewObjectSchema();
                newStep.objectSchema.name = "Step Name";
                this.formConfiguration.mySteps.push(newStep);
                /*let newProperty = this.dataSourceService.createNewSchemaProperty();
                newProperty.name = newStep.objectSchema.name;
                newProperty.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Object;
                newProperty.typeSchema = newStep.objectSchema;
    */
                this.currentStep = newStep;
                this.currentStepIndex = this.formConfiguration.mySteps.length - 1;
                this.setupFormSchema();
                this.save();
            };
            MultiStepFormModel.prototype.selectStep = function (position) {
                var _this = this;
                var index = 0;
                if (position > 0) {
                    index = Enumerable.from(this.formConfiguration.mySteps).indexOf(function (s) { return s.position == position; });
                }
                this.currentStep = this.formConfiguration.mySteps[index];
                this.currentStepIndex = position;
                ////TODO: Fix this with new form changes
                //if (this.currentStep.isCustomStep && this.customStepFunctions && this.customStepFunctions.length > 0) {
                //    this.formData = this.customStepFunctions[this.currentStep.id].stepUnload(this.isReadOnly);
                //    this.save();
                //}
                var step = Enumerable.from(this.formConfiguration.mySteps).single(function (s) { return s.position === position; });
                this.currentStep = step;
                if (this.currentStep.formSections) {
                    this.currentStep.formSections.forEach(function (g) {
                        _this.formSectionService.splitFields(g);
                    });
                }
                this.loadStepJavascript();
                this.loadFieldsConditions();
                var id = 'step' + position;
                var element = this.$window.document.getElementById(id);
                if (element) {
                    element.focus();
                    window.scrollTo(0, 0);
                }
            };
            return MultiStepFormModel;
        }(directives.BaseFormModel));
        directives.MultiStepFormModel = MultiStepFormModel;
        var MultiStepFormController = /** @class */ (function (_super) {
            __extends(MultiStepFormController, _super);
            function MultiStepFormController(scope, $window, $timeout, angularLoader, formSectionService, modalService, httpService, dataSourceService, formService, formDataService, growl, formCodeFunctionService, customDivService, manageProcessDataConfigurationService, apiActionService, securityMatrixService, deleteService) {
                var _this = this;
                scope.model = new MultiStepFormModel(angularLoader, formSectionService, modalService, httpService, dataSourceService, formService, scope.process, formDataService, growl, formCodeFunctionService, customDivService, manageProcessDataConfigurationService, apiActionService, securityMatrixService, deleteService, scope, $window, $timeout);
                _this = _super.call(this, scope) || this;
                return _this;
            }
            return MultiStepFormController;
        }(directives.BaseFormController));
        directives.MultiStepFormController = MultiStepFormController;
    })(directives = warsApp.directives || (warsApp.directives = {}));
})(warsApp || (warsApp = {}));
warsApp.registerDirective('MultiStepForm', []);
